(function (Drupal, once) {
  'use strict';

    // Auto login OpenID (vanilla JS + once)
    // Requires the core "once" library (add dependency: core/once)

    document.addEventListener('DOMContentLoaded', () => {
    // Only on the user login page.
    if (!document.body.classList.contains('page-user-login')) return;

    // Get the Keycloak login button once.
    const buttons = once(
        'autologinOpenID',
        document.querySelectorAll('#edit-openid-connect-client-keycloak-login')
    );
    if (!buttons.length) return;

    // Read the OpenID Connect form action.
    const action =
        document.querySelector('#openid-connect-login-form')?.getAttribute('action') || '';

    // Skip autologin for these cases.
    const blocked = [
        'user/login?showcore',
        'user/login%3Fshowcore',
        'user/login?samhammer',
        'user/login%3Fsamhammer',
        '/user/reset/',
    ];

    // Trigger click if none of the blocked patterns are present.
    if (blocked.every(pattern => !action.includes(pattern))) {
        buttons.forEach(btn => btn.click());
    }
    });

})(Drupal, once);